<template>
  <div class="combobox-rental-intake-item-info grow">
    <div class="flex flex-row">
      <span class="grow space-x-1">
        <FontAwesomeIcon :icon="['fas', 'cart-shopping']" class="text-red-800" title="Inhuur" />
        <span class="inline-block font-bold!">Inhuur:</span>
        <span> {{ rentalIntakeItem.supplier.name }} {{ rentalIntakeItem.name }} </span>
        <span>{{ rentalIntakeItem.getUnitName() }}</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RentalIntakeItem } from "@/models/rental-intake-item.model"
import { Instruction } from "@/models/instruction.model"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

defineProps<{
  rentalIntakeItem: RentalIntakeItem
  instruction?: Instruction
}>()

defineOptions({
  inheritAttrs: false
})
</script>

<style scoped></style>
